module.exports = __webpack_public_path__ + "assets/img/img-map-kyoto-sp.fc0036e9.svg";